export enum enumDigitalSignState {
  Requested = 0,
  Sending = 1,
  Sent = 2,
  Completed = 3,
  Cancelled = 4,
  Deleted = 5,
  FailedToSend = 6,
  Declined = 7,
}
